import script from "./BlockquoteIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockquoteIcon.vue?vue&type=script&setup=true&lang=js"

export default script